import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { ListenBylineProps } from '../src/components/listen-byline/ListenByline.tsx';

export const ListenByline: LoadableType<ListenBylineProps> = LoadableAfterPaint<ListenBylineProps>({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ListenByline" */ '../src/components/listen-byline/ListenByline.tsx'
			)
		).ListenByline,
});
